import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import {
  CUSTOMER_IO_EVENT,
  GOOGLE_TAG_MANAGER_EVENT,
  MOUSEFLOW_EVENT,
} from "@/features/analytics/models";
import {
  triggerGoogleTagManagerTracking,
  triggerMouseflowTracking,
} from "@/features/analytics/triggers";

interface TrackBmiDisqualifiedParams {
  customerIoAnalytics: AnalyticsBrowser;
}

export const trackBmiDisqualified = ({
  customerIoAnalytics,
}: TrackBmiDisqualifiedParams) => {
  triggerGoogleTagManagerTracking({
    event: GOOGLE_TAG_MANAGER_EVENT.BMI_DISQUALIFIED,
  });

  triggerMouseflowTracking({ event: MOUSEFLOW_EVENT.BMI_DISQUALIFIED });

  void customerIoAnalytics.track(CUSTOMER_IO_EVENT.BMI_DISQUALIFIED, {
    source: window.location.href,
  });
};
